import Papa from "papaparse";

export const smallVesselCoeff = {
    sailboat: null,
    yacht: null,
};

export function preloadSmallVesselCoefficients() {
    return new Promise((resolve, reject) => {
        let loaded = 0;

        function load(type, path) {
            Papa.parse(path, {
                download: true,
                header: true,
                dynamicTyping: true,
                complete: (results) => {
                    smallVesselCoeff[type] = results.data;
                    loaded++;


                    if (loaded === 2) {
                  
                        resolve();
                    }
                },

                error: reject,
            });
        }

        load("sailboat", "/coefficients/per_hz_coefficients_sailboat.csv");
        load("yacht", "/coefficients/per_hz_coefficients_yachts.csv");

    });
    
}
